/* eslint-disable sonarjs/cognitive-complexity */
import React from 'react';
import Input from '../input/input';
import Select from '../select/select';
import { Container } from './style';

import {
  BaSeCheckbox,
  BaSeHeading5,
  BaSeParagraph,
  BaSeTheme,
} from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import { FormContext } from '../../hook/form-context';
import { useDisplay } from '../../hook/useDisplay';

function FormPersonalData({ handleChangePersonalData, personalData }) {
  const { isAuthenticated } = Sebrae.useAuth();
  const {
    formatCpf,
    acept,
    setAcept,
    showInterestCity,
    listCity,
    interestCityOption,
    setInterestCityOption,
  } = React.useContext(FormContext);
  const { breakpointController } = useDisplay();

  const returnMessage =
    breakpointController.inMobile || breakpointController.inMobileLarge ? (
      <BaSeHeading5 color={'#fff'}>Informe os seus dados pessoais</BaSeHeading5>
    ) : (
      <></>
    );

  return (
    <>
      {returnMessage}
      <Container>
        <Input
          value={personalData.name}
          placeholder="Preencha seu nome completo"
          label="Nome:"
          onChange={(e) => handleChangePersonalData('name', e.target.value)}
          isDisabled={isAuthenticated}
        />
        <Input
          value={personalData.cpf}
          placeholder="Preencha seu CPF"
          label="CPF:"
          onChange={(e) => {
            const formattedValue = formatCpf(e.target.value);
            if (formattedValue.length > 14) return;
            handleChangePersonalData('cpf', formattedValue);
          }}
          isDisabled={isAuthenticated}
        />
        <Input
          value={personalData.email}
          type="email"
          placeholder="Preencha seu melhor e-mail"
          label="E-mail:"
          onChange={(e) => handleChangePersonalData('email', e.target.value)}
        />
        <Input
          value={personalData.contato}
          placeholder="DDD + telefone"
          label="Contato:"
          onChange={(e) => {
            const rawValue = e.target.value.replace(/\D/g, '');

            let formattedValue = '';
            if (rawValue.length <= 10) {
              formattedValue = rawValue.replace(
                /(\d{2})(\d{4})(\d{0,4})/,
                '($1) $2-$3',
              );
            } else {
              formattedValue = rawValue.replace(
                /(\d{2})(\d{5})(\d{0,4})/,
                '($1) $2-$3',
              );
            }

            if (formattedValue.length > 15) return;
            handleChangePersonalData('contato', formattedValue);
          }}
        />
        {showInterestCity && (
          <Select
            label="Cidade:"
            placeholder="Informe a cidade"
            options={listCity.filter((city) => city.id)}
            value={interestCityOption}
            onChange={(event) => setInterestCityOption(event.target.value)}
          />
        )}
      </Container>

      <div style={{ display: 'flex', alignItems: 'center', marginTop: 18 }}>
        <BaSeCheckbox
          value={acept}
          checked={acept}
          onChange={() => setAcept((prev) => !prev)}
        />
        <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae97}>
          Aceito receber contato do Sebrae.
        </BaSeParagraph>
      </div>
    </>
  );
}

export default FormPersonalData;
